import { formatDate } from '../date-time';
import { Alert } from '../domain';
import { orignalGreen, origninalRed, yellow } from '../theme';

export function alertToString(alert: Alert): string {
  if (!alert) {
    return 'Alert';
  }

  let { errorText, description, alertType, details, createDate } = alert;

  let result = (alert?.label || alertType) + ': ' + (description || '').replace(/(\r\n|\n|\r)/gm, ' ');

  if (errorText) {
    result += '\n\n' + errorText.replace(/(\r\n|\n|\r)/gm, ' ');
  }

  if (details) {
    //  console.log('alert details', details.tuples,  alert.details)
    const tuples = details.tuples;
    if (tuples?.length) {
      result += '\n\n MIPS Tuples:';
      tuples.forEach((v) => {
        result += '\n' + v.cptCode + ' - ' + v.description + ' Modifier' + (v.modifier || '');
      });
    }
    const dxCodes = details.dxCodes;
    if (dxCodes?.length) {
      result += '\n\n MIPS DX codes:\n' + dxCodes.join(', ');
    }

    const { macName, sourceData } = details;
    if (macName) {
      result += '\n\n' + macName;
    }

    if (sourceData) {
      result += '\n\n' + sourceData;
    }
  }

  if (createDate) {
    result += '\n\nCreate Date: ' + formatDate(createDate);
  }

  return result;
}

export function alertComplete(a: Alert): boolean {
  return a.resolved || a.overridden || a.acknowledged;
}

export function alertColor(a: Alert): string {
  if (alertComplete(a)) {
    return orignalGreen;
  }

  if (a.infoOnly) {
    return yellow;
  }
  return origninalRed;
}

export function incompleteAlerts(alerts: Alert[]): Alert[] {
  if (!alerts) return [];
  return alerts.filter((a) => !alertComplete(a));
}

function sortByComplete(a: Alert, b: Alert): number {
  return alertComplete(a) === alertComplete(b) ? 0 : alertComplete(a) ? 1 : -1;
}

export function sortAlerts(alerts: Alert[]): Alert[] {
  return (alerts || []).sort(sortByComplete);
}
